import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg width="68" height="79" viewBox="0 0 68 79" fill="none" {...props}>
      <g clip-path="url(#clip0_1654_11986)">
        <path d="M45.3355 19.6281V32.7177L34 26.1708L45.3355 19.6281Z" fill="black" />
        <path d="M45.3355 32.7177V45.8031L34 39.2604L45.3355 32.7177Z" fill="black" />
        <path d="M22.6673 32.7177V45.8031L11.334 39.2604L22.6673 32.7177Z" fill="black" />
        <path d="M45.3355 45.8031L34 52.3458V39.2604L45.3355 45.8031Z" fill="black" />
        <path d="M33.9994 39.2604V52.3458L22.666 45.8031L33.9994 39.2604Z" fill="black" />
        <path d="M33.9994 13.0854V26.1708L22.666 19.6281L33.9994 13.0854Z" fill="black" />
        <path d="M45.3355 19.6281L34 26.1708V13.0854L45.3355 19.6281Z" fill="black" />
        <path d="M33.9994 26.1708L22.666 32.7177V19.6281L33.9994 26.1708Z" fill="black" />
        <path d="M56.6671 39.2604L45.3359 45.8031V32.7177L56.6671 39.2604Z" fill="black" />
        <path d="M56.6671 26.1708L45.3359 32.7177V19.6281L56.6671 26.1708Z" fill="black" />
        <path d="M33.9994 39.2604L22.666 45.8031V32.7177L33.9994 39.2604Z" fill="black" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.9994 39.2604V26.1708L22.666 32.7177L33.9994 39.2604ZM34 39.2604L45.3355 32.7177L34 26.1708V39.2604Z"
          fill="#FFCC47"
        />
        <path d="M56.6671 65.4311L45.3359 71.9737V58.8884L56.6671 65.4311Z" fill="black" />
        <path d="M45.3355 58.8884V71.9737L34 65.4311L45.3355 58.8884Z" fill="black" />
        <path d="M22.6673 19.6281V32.7177L11.334 26.1708L22.6673 19.6281Z" fill="black" />
        <path d="M33.9994 52.3457V65.4311L22.666 58.8884L33.9994 52.3457Z" fill="black" />
        <path d="M33.9994 65.4311L22.666 71.9737V58.8884L33.9994 65.4311Z" fill="black" />
        <path d="M22.6673 32.7177L11.334 39.2604V26.1708L22.6673 32.7177Z" fill="black" />
        <path d="M22.6673 45.8031L11.334 52.3458V39.2604L22.6673 45.8031Z" fill="black" />
        <path d="M45.3355 58.8884L34 65.4311V52.3457L45.3355 58.8884Z" fill="black" />
        <path d="M56.6671 39.2604V52.3458L45.3359 45.8031L56.6671 39.2604Z" fill="black" />
        <path d="M56.6671 26.1708V39.2604L45.3359 32.7177L56.6671 26.1708Z" fill="black" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M34 0.000106812L45.3355 6.54277V19.6281L34 13.0854V0.000106812ZM33.9994 13.0854L22.6673 19.6274V19.6281L11.334 26.1708V13.0854L22.666 6.54352V6.54277L33.9994 0.000106812V13.0854ZM22.6673 58.8877L33.9994 52.3457L22.6673 45.8038V45.8031L22.6667 45.8034L22.666 45.8031V45.8038L11.334 52.3457V65.4311L22.6673 58.8884V58.8877ZM56.666 65.4311L56.6666 65.4307L56.6671 65.4311V65.4304L67.9994 58.8884V45.8031V32.7177V19.6281L56.6671 13.0861V13.0854L45.3359 6.54277V19.6281L56.666 26.1701V26.1708V39.2604V52.3451L45.3359 45.8031V58.8884L56.666 65.4304V65.4311ZM11.3333 26.1708V39.2604V52.3457V65.4311L0 58.8884V45.8031V32.7177V19.6281L11.3333 13.0854V26.1708ZM45.3355 71.9737L34 78.5164V65.4311L45.3355 71.9737ZM45.3355 45.8031V58.8884L34 52.3457L45.3355 45.8031ZM22.666 71.9737L33.9994 78.5164V65.4311L22.666 71.9737Z"
          fill="white"
        />
        <path d="M22.6673 58.8884V71.9737L11.334 65.4311L22.6673 58.8884Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_1654_11986">
          <rect width="68" height="78.5163" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default Icon;
